<template>
  <v-form @submit.prevent="getActionMethod">
    <v-container>
      <v-row align="center" justify="center">
        <span class="red--text font-weight-bold">{{
          formValidator.getError("non_field_errors")
        }}</span>
        <v-col md="6" cols="12">
          <v-text-field
            v-model="formValues.title"
            label="Title of the Note"
            placeholder="Title of the Note"
            :error-messages="formValidator.getError('title')"
          ></v-text-field>
          <vue-tip-tap
            v-model="formValues.template"
            placeholder="Write a description of notes template"
            :error-messages="formValidator.getError('template')"
          ></vue-tip-tap>
        </v-col>
        <v-col cols="12"></v-col>
        <v-col md="6" cols="12">
          <v-divider class="my-2"></v-divider>
          <v-btn
            :disabled="Object.keys(formValidator.errors).length > 0"
            class="primary"
            type="submit"
          >
            Save
          </v-btn>
          <v-btn type="reset">
            Reset
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>
<script>
import { FormValidator } from "rhr-core-shell";
export default {
  props: {
    actionData: {
      type: Object,
      required: false,
      default() {
        return {
          title: "",
          template: "",
          organization: ""
        };
      }
    }
  },
  data() {
    return {
      formValues: { ...this.actionData },
      formValidator: new FormValidator()
    };
  },
  watch: {
    formValues: {
      handler() {
        this.formValidator.setError({});
      },
      deep: true
    }
  },
  methods: {
    getActionMethod() {
      if (this.formValues.id) return this.updateNotesTemplate();
      return this.createNotesTemplate();
    },
    createNotesTemplate() {
      const notesTemplateAPI = `/api/v1/crm/notes-templates/?organization__slug=${this.$route.params.orgSlug}`;
      this.formValues.organization = this.$route.params.orgSlug;
      this.$axios
        .$post(notesTemplateAPI, this.formValues)
        .then(() => {
          this.$store.dispatch("shell/showSnackbar", {
            text: `Successfully created notes template!`,
            color: "green"
          });
          this.$emit("notesTemplateFormResponse", "created");
        })
        .catch(error => {
          this.formValidator.setError(error.response.data);
        });
    },
    updateNotesTemplate() {
      const notesTemplateAPI = `/api/v1/crm/notes-templates/${this.formValues.id}?organization__slug=${this.$route.params.orgSlug}`;
      this.$axios
        .$patch(notesTemplateAPI, this.formValues)
        .then(() => {
          this.$store.dispatch("shell/showSnackbar", {
            text: `Successfully updated notes template!`,
            color: "green"
          });
          this.$emit("notesTemplateFormResponse", "updated");
        })
        .catch(error => {
          this.formValidator.setError(error.response.data);
        });
    }
  }
};
</script>
